var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPlugChademoSmall(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 32 32",
    style: {
      enableBackground: "new 0 0 32 32"
    },
    xmlSpace: "preserve",
    fill: "currentColor",
    stroke: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M9,12.5c-1.9296875,0-3.5,1.5703125-3.5,3.5s1.5703125,3.5,3.5,3.5s3.5-1.5703125,3.5-3.5S10.9296875,12.5,9,12.5z M9,17.5 c-0.8271484,0-1.5-0.6728516-1.5-1.5s0.6728516-1.5,1.5-1.5s1.5,0.6728516,1.5,1.5S9.8271484,17.5,9,17.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23,12.5c-1.9296875,0-3.5,1.5703125-3.5,3.5s1.5703125,3.5,3.5,3.5s3.5-1.5703125,3.5-3.5S24.9296875,12.5,23,12.5z  M23,17.5c-0.8271484,0-1.5-0.6728516-1.5-1.5s0.6728516-1.5,1.5-1.5s1.5,0.6728516,1.5,1.5S23.8271484,17.5,23,17.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16,1C7.7285156,1,1,7.7285156,1,16s6.7285156,15,15,15s15-6.7285156,15-15S24.2714844,1,16,1z M16,29 C8.8320312,29,3,23.1679688,3,16S8.8320312,3,16,3s13,5.8320312,13,13S23.1679688,29,16,29z"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "17.7929688,5.7929688 16,7.5859375 14.2070312,5.7929688 12.7929688,7.2070312 14.5859375,9  12.7929688,10.7929688 14.2070312,12.2070312 16,10.4140625 17.7929688,12.2070312 19.2070312,10.7929688 17.4140625,9  19.2070312,7.2070312  "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "17.7929688,19.7929688 16,21.5859375 14.2070312,19.7929688 12.7929688,21.2070312 14.5859375,23  12.7929688,24.7929688 14.2070312,26.2070312 16,24.4140625 17.7929688,26.2070312 19.2070312,24.7929688 17.4140625,23  19.2070312,21.2070312  "
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlugChademoSmall);
export default __webpack_public_path__ + "static/media/plug-chademo--small.dc6d278e9e5c49cb2db61ff85199bdd1.svg";
export { ForwardRef as ReactComponent };